import React from 'react';
import { Button, Modal } from "reactstrap";

const ESCALATION_MODAL_TEXT_COLOR = '#627386';

const EscalationModal = ({ yes_del, no_del, text, onClose }) => {
	return (
		<div className='custom-ui'>
			<Modal isOpen={true} className='modal-dialog-centered'>
				<div>
					<div className="modal-header bg-gradient-white">
						<h4 className="modal-title" id="modal-title-notification">
							<span style={{ color: ESCALATION_MODAL_TEXT_COLOR }}>Multiple Product Done Tickets</span>
						</h4>
						<button
							aria-label="Close"
							aria-describedby="escalation-modal-content"
							className="close"
							data-dismiss="modal"
							type="button"
							onClick={onClose}
						>
							<span aria-hidden={true}>×</span>
						</button>
					</div>
					<div className="modal-body bg-gradient-secondary">
						<div className="py-3 text-center">
							<h4
								id="escalation-modal-content"
								style={{ color: '#627386', fontSize: '16px' }}
								className=""
							>
								{text ? text : 'Are you sure you want to proceed?'}
							</h4>
						</div>
					</div>
					<div className="modal-footer" style={{ padding: '10px' }}>
						<Button className="white_button" type="button" onClick={() => { if (no_del) no_del(); onClose() }}>
							Take me back
						</Button>
						<Button color='warning' type="button" onClick={() => { yes_del(); onClose() }}>
							Escalate
						</Button>
					</div>
				</div>
			</Modal>
		</div>
	);
}

export default EscalationModal;
